import { createContext } from 'react';
export default /*#__PURE__*/createContext({
  exchange: function exchange(value) {
    return value;
  },
  exchangeBack: function exchangeBack(value) {
    return value;
  },
  currentCurrency: 'USD'
});